export const USER_LIST = 'user-list'
export const USER_DETAILS = 'user-details'
export const CLEAR_USER_DETAILS = 'clear-user-details'
export const UPDATE_USER_STATE = 'update-user-state'
export const UPDATE_USER_ROLES = 'update-user-roles'
export const DELETE_USER = 'delete-user'
